import { Log } from '@/types/logs'
import { useAuthStore } from '@/store/auth-store'
import { FlagTooltip } from '@/pages/Flagged/ui/components/FlagTooltip'
import { FlagStateIcon } from './FlagStateIcon'

interface Props {
    log: Log
}

export const FlaggedCell = ({ log }: Props) => {
    const { unfinishedFlagMetadata } = log
    const { role } = useAuthStore()

    return (
        <FlagTooltip logId={log.id} metadata={unfinishedFlagMetadata ?? null} role={role}>
            <FlagStateIcon metadata={unfinishedFlagMetadata} />
        </FlagTooltip>
    )
}
